import React from 'react';
import styled from 'styled-components';
import { PublicPhotoObject } from './PhotoObject';
import { Fields } from '../styles';

const PhotoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const Phase2 = ({ imageObjects }: { imageObjects: Array<object> }) => {
  return (
    <Fields style={{ flexDirection: 'column' }}>
      <PhotoGrid>
        {imageObjects
          ? imageObjects.map((item: any) => (
              <PublicPhotoObject key={item.id} photoDetails={item} />
            ))
          : null}
      </PhotoGrid>
    </Fields>
  );
};

export default Phase2;
